import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { useLocation } from "react-router-dom";
import "./CustomerRefundPrint.css";
import { Button } from "antd";
import CustomerRefundPrintHeader from "./CustomerRefundPrintHeader/CustomerRefundPrintHeader";
import { getCustomerPaymentPrint } from "../../redux/actions/customerPaymentPrint.action";
import { getOneCustomerPaymentLine } from "../../redux/actions/customerPaymentLine.action";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import numeral from "numeral";
import { getOneCustomerRefundLine } from "../../redux/actions/customerRefundLine.action";
import { getCustomerRefundPrint } from "../../redux/actions/customerRefundPrint.action";
import Loader from "react-loader-spinner";


const CustomerRefundPrint = () => {
  TabTitle("Customer Refund Print")
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const { customerRefundPrint } = useSelector((state) => state);

  const [data, setData] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }



  let query = useQuery();

  let refund_header_id = query.get("refund_header_id");

  const headerData =
    customerRefundPrint?.payload?.data?.length > 0 && customerRefundPrint?.payload?.data[0];

  const values = {
    refund_header_id: refund_header_id,
  };

  console.log("headerData", headerData);
  console.log("data", data);

  useEffect(() => {
    dispatch(getCustomerRefundPrint(token, values));
    dispatch(getOneCustomerRefundLine(token, refund_header_id)).then((res) => {
      if (res.type === "GET_ONE_CUSTOMER_REFUND_LINE_SUCCESS") {
        setData(res.payload.data);
      }
    });
  }, [refund_header_id]);



  const handlePrint = () => {
    const css = '@page { size: landscape;  margin: 2mm 10mm !important; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (customerRefundPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  const totalAmount = data
    ?.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

  const totalRemainingAmount = data
    ?.reduce((sum, item) => sum + (Number(item.remaining_amount) || 0), 0);

  const totalAppliedAmount = data
    ?.reduce((sum, item) => sum + (Number(item.applied_amount) || 0), 0);

  return (
    <div className="__customer_refund_report"    >
      <table width="100%">
        <thead>
          <tr>
            <td>
              <CustomerRefundPrintHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={data} amount={totalAppliedAmount} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Body = ({ myData, amount, footerData }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">

          <table width="100%">
            <tbody>
              <tr>
                <th
                  style={{
                    width: "36px",
                  }}
                >
                  S.No
                </th>
                <th
                  style={{
                    width: "88px",
                  }}
                >
                  Transaction Type
                </th>
                <th
                  style={{
                    width: "80px",
                    textAlign: "right",
                    paddingRight: 5
                  }}
                >
                  Transaction No #
                </th>

                <th
                  style={{
                    width: "70px",
                  }}
                >
                  Transaction Date
                </th>
                <th
                  style={{
                    width: "90px",
                    textAlign: "right",
                    paddingRight: 5
                  }}
                >
                  RA #
                </th>
                <th
                  style={{
                    width: "90px",
                    textAlign: "right",
                    paddingRight: 5
                  }}
                >
                  Invoice #
                </th>

                <th
                  style={{
                    width: "90px",
                    textAlign: "right",
                    paddingRight: 5
                  }}
                >
                  Reciept #
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Gender Name
                </th>
                <th
                  style={{
                    width: "90px",
                  }}
                >
                  Term Name
                </th>
                <th
                  style={{
                    width: "90px",
                    textAlign: "right",
                    paddingRight: 5
                  }}
                >
                  Amount
                </th>
              </tr>
              {
                myData?.map((it, index) => {
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          marginLeft: "0",
                        }}
                      >
                        {index}
                      </td>
                      <td>
                        {it?.transaction_type}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.note_header_no}
                      </td>
                      <td>
                        {moment(it?.note_date).format("MM-DD-YYYY")}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.ra_no}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.invoice_header_no}
                      </td>

                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {it?.receipt_header_no}
                      </td>
                      <td>
                        {it?.gender_name}
                      </td>
                      <td>
                        {it?.term_name}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 5
                        }}
                      >
                        {numeral(it?.applied_amount).format("00.00")}
                      </td>
                    </tr>
                  )
                })
              }

            </tbody>
          </table>

        </div>
      </div>
      <div className="__summary_box">
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td width="250px">
                <table width="100%" className="__summary_box_table">
                  <tbody>

                    <tr>
                      <td>
                        Refund Amount
                      </td>
                      <td
                        style={{ textAlign: "right" }}
                      >
                        $ {numeral(amount).format("00.00")}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}




export default CustomerRefundPrint;